export default __webpack_public_path__ + "static/media/ResultInfo.2416399a.png";